import { cva } from '@/styled-system/css';

export const tableSortIconRecipe = cva({
  base: {
    color: 'icon.action.hero.default',

    _groupActive: {
      color: 'icon.action.hero.default',
    },
    _groupHover: {
      color: 'icon.action.hero.default',
      opacity: 1,
    },
    _groupFocusVisible: {
      opacity: 1,
    },
  },
  variants: {
    selected: {
      true: {
        opacity: 1,
        color: 'icon.action.hero.default',
      },
      false: {
        opacity: 0,
      },
    },
  },
});
